var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 400,
    viewBox: "0 0 292 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_1919)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 146,
    cy: 200,
    rx: 146,
    ry: 200,
    fill: "#FFDE49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 400C226.578 400 291.911 310.579 292 200.226V200H0C0 310.457 65.3664 400 146 400Z",
    fill: "#FFEA89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_1919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 291.989,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillYellow);
export default __webpack_public_path__ + "static/media/pill_yellow.f6568f60b5325808e9819815fd3740d0.svg";
export { ForwardRef as ReactComponent };